import { OrganizationDto } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { Button, Dialog, DialogContent } from '@sib/ui';
import { InformationWrapper } from '@sib/ui';
import { AskSpendBrain, X } from '@sib/ui/icons';
import { ActivateAiModalFooter } from './ActivateAiModalFooter';

interface ActivateAiModalProps {
  isOpen: boolean;
  onClose: () => void;
  organization?: OrganizationDto;
}

export const ActivateAiModal = ({
  isOpen,
  onClose,
  organization,
}: ActivateAiModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex max-h-[90vh] w-full max-w-[90vw] flex-col items-center gap-7 px-6 py-6 pb-10 sm:max-w-[70vw] sm:px-12 xl:max-w-[60vw]">
        <div className="flex w-full justify-end">
          <Button
            onClick={onClose}
            size="icon"
            variant="ghost"
            className="text-primary"
          >
            <X className="text-primary" />
          </Button>
        </div>
        <div className="flex flex-col items-center gap-7">
          <InformationWrapper
            icon={<AskSpendBrain className="size-27" aria-hidden="true" />}
            title={t('aiServiceModal.askSpendBrainModalTitle')}
            description={t('aiServiceModal.askSpendBrainModalDescription')}
            className="mt-0"
            footer={<ActivateAiModalFooter organization={organization} />}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
